// src/utils/choixMachineFnct.ts — SCE Issues
// « Une FNC-T, sur quelle machine ? » (15/10, « machine d'abord ») : le bouton
// central et « + Nouvelle FNC-T » de /fnct font d'abord choisir la machine. Pur,
// testable.
//
// Champ vide : les machines en fabrication (là où naissent les FNC-T de test).
// Deux caractères : le référentiel, par N° de série, OF, PN ou CVE (graphies non
// normalisées : cleRapprochement), le N° de série qui COMMENCE par la saisie en tête.

import { cleRapprochement, type Equipement } from '@/types/issue.types'

export const MAX_MACHINES = 30

export function machinesPourFnct(
  referentiel: readonly Equipement[],
  texte: string,
  enFabrication: ReadonlySet<string>,
): Equipement[] {
  const q = cleRapprochement(texte)
  if (q.length < 2) {
    return referentiel
      .filter((eq) => enFabrication.has(cleRapprochement(eq.numeroSerie)))
      .sort((a, b) => a.numeroSerie.localeCompare(b.numeroSerie, 'fr'))
      .slice(0, MAX_MACHINES)
  }
  const rang = (eq: Equipement): number => {
    const ns = cleRapprochement(eq.numeroSerie)
    if (ns.startsWith(q)) return 0
    if (ns.includes(q)) return 1
    if ([eq.of, eq.pn, eq.cve ?? ''].some((v) => cleRapprochement(v).includes(q))) return 2
    return 3
  }
  return referentiel
    .map((eq) => ({ eq, r: rang(eq) }))
    .filter((x) => x.r < 3)
    .sort((a, b) => a.r - b.r || a.eq.numeroSerie.localeCompare(b.eq.numeroSerie, 'fr'))
    .slice(0, MAX_MACHINES)
    .map((x) => x.eq)
}
